import { useTheme } from '@mui/material';
import DSBox from '../../design-system/DSBox';
import { DSTypography } from '../../design-system/Typography';
import DSSwitch from '../../design-system/DSSwitch';
import GiftView from './GiftView';
import useGiftQuery from './hooks/useGiftQuery';
import { useHistory } from './hooks/useHistory';
import { GreetSplashScreen } from './GreetSplashScreen';
import { useState } from 'react';
import { KLYDO_YELLOW } from '../../consts/colors';
import GreetLogo from './GreetLogo';
import { isIOS, isMobile } from 'react-device-detect';
const GIFT_SCALE_DESKTOP = 290 / 643;
const GIFT_SCALE_IOS = 250 / 643;

const GiftShare = () => {
  const theme = useTheme();
  const { search } = useHistory();

  const { data: giftInfo, isLoading: isLoadingGift } = useGiftQuery({
    orderName: (search.orderName || search.orderId) as string,
    clockId: search.clockId as string,
  });

  const gift = giftInfo?.gift;
  const selectedKlydoGreet = gift?.klydo;
  const klydoGiftProps = {
    senderImageUrl: gift?.senderImageUrl,
    senderName: gift?.senderName,
    date: gift?.date,
    greetingContent: gift?.greetingContent,
    pendulumLogoUrl: gift?.pendulumLogoUrl,
    pendulumLogoType: gift?.pendulumLogoType,
    orderName: gift?.orderName || '',
    clockId: giftInfo?.clockInfo?.id || '',
    klydoId: gift?.klydoId,
    timeZone: gift?.timeZone,
    giftId: gift?.giftId,
  };

  const [showGreeting, setShowGreeting] = useState(false);

  if (isLoadingGift) return <GreetSplashScreen />;

  return (
    <DSBox
      sx={{
        minHeight: '100vh',
        overflow: 'scroll',
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <DSBox
        sx={{
          backgroundColor: theme.palette.background.paper,
          paddingY: 4,
          display: 'flex',
          justifyContent: 'center',
          textAlign: 'center',
          alignItems: 'center',
        }}
      >
        <GreetLogo color={KLYDO_YELLOW} width={isMobile ? 150 : 200} />
      </DSBox>

      <DSBox
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <GiftView
          gift={klydoGiftProps}
          klydo={selectedKlydoGreet!}
          isToggled={showGreeting}
          scale={isIOS && isMobile ? GIFT_SCALE_IOS : GIFT_SCALE_DESKTOP}
        />
        <DSBox
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '10px',
            width: '100%',
            mt: 1,
          }}
        >
          <DSTypography
            sx={{
              fontFamily: 'Gilroy-SemiBold',
              fontSize: '16px',
              color: showGreeting ? '#A5A5A5' : '#FFFFFF',
            }}
          >
            Greet
          </DSTypography>
          <DSSwitch
            checked={showGreeting}
            onChange={(e) => setShowGreeting(e.target.checked)}
          />
          <DSTypography
            sx={{
              fontFamily: 'Gilroy-SemiBold',
              fontSize: '16px',
              color: showGreeting ? '#FFFFFF' : '#A5A5A5',
            }}
          >
            Message
          </DSTypography>
        </DSBox>
      </DSBox>
    </DSBox>
  );
};

export default GiftShare;
